import { useNavigate, useSearchParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { CustomerScansController } from "./customer-scans-controller";
import { CustomerScansPage } from "./customer-scans-page";

/** The selected customer lives in the URL; a different one gets a fresh controller through `deps`. */
export function CustomerScansRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const customerId = params.get("customer");
  // Where the scan-review screen returns after approve/reject: the exact view
  // the owner left, so the customer's scan list re-renders in place.
  const returnTo = customerId ? `/customer-scans?customer=${customerId}` : undefined;
  return (
    <Subtree
      key="customer-scans"
      deps={[customerId]}
      controller={() =>
        new CustomerScansController(
          { customerId },
          pick(
            deps,
            "client",
            "authHandler",
            "storeRepository",
            "providersRepository",
            "customersRepository",
            "pendingCartsRepository",
          ),
          {
            showCustomer: (id) => setParams({ customer: id }),
            showAllCustomers: () => setParams({}),
            editScan: (scanId) => navigate(`/customer-scans/${scanId}/edit`, { state: { returnTo } }),
            scanFor: (id) => navigate(`/scan?customer=${encodeURIComponent(id)}`),
            openCart: (cartId) => navigate(`/customer-carts?cart=${encodeURIComponent(cartId)}`),
          },
        )
      }
    >
      <CustomerScansPage />
    </Subtree>
  );
}
